import requests from './httpService';
const TrainerRegistrationService = {
  getAllTrainerRegistration(id) {
    return requests.post(`/trainerregistration/find`);
  },
  
  getStudentTrainerRegistration(id) {
    return requests.get(`/trainerregistration/list/${id}`);
  },
  getAllTrainerRegistrationById(id,body){
    return requests.post(`/trainerregistration/list/${id}`,body); 
  },
  upadeTrainer(body) {
    return requests.put(`/trainerregistration/${body._id}`,body); 
  },
  creteTrainerRegistration(body){
    return requests.post('/trainerregistration/add',body); 
  },
  deleteTrainerRegistration(body){
    return requests.delete(`/trainerregistration/${body._id}`); 
  },
  
findTrainerRegistrationList(body){
  return requests.post(`/trainerregistration/find`,body); 
},
  upadeTrainerRegistration(body) {
    return requests.put(`/trainerregistration/${body._id}`,body); 
  },
 uploadImage(body) {
    return requests.post(`/trainerregistration/uploadimage`,body);
  },

};

export default TrainerRegistrationService;
